import { Screen, SecondaryButton, Title } from './kit';
import { TERMS } from './termsText';

/** Условия использования.
 *
 *  Отдельный экран, а не абзац внутри политики: политика говорит о данных,
 *  условия — о договорённости. Смешивать их значит прятать отказ от
 *  гарантий внутри документа, который родитель открывает ради другого. */
export function TermsScreen({ onBack }: { onBack: () => void }) {
  return (
    <Screen>
      <Title>{TERMS.title}</Title>
      <p className="m-0 text-[0.85rem] text-muted">Редакция от {TERMS.updated}</p>
      {TERMS.sections.map((section) => (
        <section key={section.heading} className="flex flex-col gap-2">
          <h2 className="m-0 text-lg font-semibold">{section.heading}</h2>
          {section.paragraphs.map((text) => (
            <p key={text.slice(0, 24)} className="m-0 text-[0.95rem] text-ink">
              {text}
            </p>
          ))}
        </section>
      ))}
      <SecondaryButton bottom onClick={onBack}>
        Назад
      </SecondaryButton>
    </Screen>
  );
}
